import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import tasks from './modules/tasks'
import protocols from './modules/protocols'
import amendments from './modules/amendments'
import committees from './modules/committees'
import magazines from './modules/magazines'
import users from './modules/users'
import articles from './modules/articles'
import bookschapters from './modules/bookschapters'
import presentations from './modules/presentations'
import catalogs from './modules/catalogs'

Vue.use(Vuex)

const state = {
	user: null,
	accessToken: null,
	preferences: {},
}

export default new Vuex.Store({
	state,
	actions,
	mutations,
	getters,
	modules: {
		tasks,
		protocols,
		amendments,
		committees,
		magazines,
		users,
		articles,
		bookschapters,
		presentations,
		catalogs,
	},
})
